import isArray from "lodash/isArray";
import isString from "lodash/isString";
import isObject from "lodash/isObject";
import isEmpty from "lodash/isEmpty";
import uniqBy from "lodash/uniqBy";

export const antdSelectFilterOption = (input, option) => {
  let children = option.children || [];

  if (isObject(children)) {
    children = option.title || [];
  }

  if (isArray(children) && children.length) {
    return children[0].toLowerCase().includes(input.toLowerCase());
  }

  return children && isString(children) ? children.toLowerCase().includes(input.toLowerCase()) : false;
};

export const customAntdSelectFilterOption =
  (searchFields = []) =>
  (input, option = {}) => {
    const { data = {} } = option.props || {};
    let result = false;

    if (!isEmpty(data)) {
      searchFields.forEach((field) => {
        const fieldValue = data[field];
        if (fieldValue?.toLowerCase().includes(input.toLowerCase())) {
          result = true;
        }
      });
    }

    return result;
  };

export const prepareInitialOptions = (initialValue, textAccessor, valueAccessor, options = []) => {
  let result = [...options];

  if (isEmpty(initialValue)) {
    return uniqBy(result, (item) => valueAccessor(item));
  }

  if (isArray(initialValue)) {
    const filteredInitialValue = initialValue
      .map((item) => ({ ...item, value: valueAccessor(item), text: textAccessor(item) }))
      .filter((item) => {
        return !options.some((option) => valueAccessor(option) === valueAccessor(item));
      });
    result = [...filteredInitialValue, ...options];
  } else if (isObject(initialValue)) {
    const initialValueIsInOptions = result.find((item) => valueAccessor(item) === valueAccessor(initialValue));
    if (!initialValueIsInOptions) {
      result = [{ ...initialValue, value: valueAccessor(initialValue), text: textAccessor(initialValue) }, ...options];
    }
  }

  return uniqBy(result, (item) => valueAccessor(item));
};
